/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Équipe • Plus de 50 membres',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Équipe • Plus de 50 membres, dont vous',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Équipe • 1 membre} other {Équipe • {0} membres}}',
  'fabric.elements.mentions.team.member.count.including.you':
    '{0, plural, one {Équipe • 1 membre, dont vous} other {Équipe • {0} membres, dont vous}}',
  'fabric.elements.mentions.xproduct.mention.description': "A besoin d'un accès à Confluence",
  'fabric.mention.error.defaultAction': 'Réessayez dans quelques secondes',
  'fabric.mention.error.defaultHeadline': "Une erreur s'est produite",
  'fabric.mention.error.differentText': 'Essayer de modifier le texte',
  'fabric.mention.error.loginAgain': 'Essayez de vous déconnecter et de vous reconnecter',
  'fabric.mention.noAccess.label': 'Aucun accès',
  'fabric.mention.noAccess.warning': "{name} ne sera pas prévenu, car cet utilisateur n'a pas d'accès",
  'fabric.mention.unknow.user.error': 'Utilisateur inconnu {userId}',
};
